export default __webpack_public_path__ + "static/media/bg_landing_page_mobile.4d3589db.svg";